// extracted by mini-css-extract-plugin
export var adjacentSlide = "_ob-9";
export var arrowButtonContainer = "_ob-5";
export var arrowButtonIcon = "_ob-6";
export var carouselArrowButton = "_ob-2";
export var carouselElementContainer = "_ob-1";
export var currentSlide = "_ob-8";
export var left = "_ob-3";
export var otherSlide = "_ob-a";
export var productCarouselContainer = "_ob-0";
export var right = "_ob-4";
export var sliderOverflow = "_ob-7";